// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { Link } from 'react-router-dom'
import antennaIcon from 'images/path-details-antenna.png'
import pathImage from 'images/path-details-site.png'
import radioIcon from 'images/path-details-radio.png'

const radioIconStyle = {
  position: 'relative',
  top: '-.125em',
}

const Menu = () => (
  <>
    <Link
      id={'header-menu-database-management-antenna'}
      to={'/database-management/antenna'}>
      <img
        alt={'home page cta path icon'}
        src={antennaIcon} />
      {'Antenna'}
    </Link>
    <Link
      id={'header-menu-database-management-path'}
      to={'/database-management/path'}>
      <img
        alt={'home page cta path icon'}
        src={pathImage} />
      {'Path'}
    </Link>
    <Link
      id={'header-menu-database-management-radio'}
      to={'/database-management/radio'}>
      <img
        alt={'home page cta radio icon'}
        src={radioIcon}
        style={radioIconStyle} />
      {'Radio'}
    </Link>
  </>
)

export default Menu
